export const imageCompressConstants = {
  categoriesBanner: '?h=1280&fm=avif&q=40/',
  _galleryThumb: '?w=1920&h=1080&fm=avif&q=10/',
  searchResultThumb: '?w=100&h=100&fm=avif&q=10',
  productCardThumb: '?h=512&fm=avif&q=10/',
  productBannerThumb: '?h=1920&fm=avif&q=10/',
  productSliderPreview: '?h=1280&fm=avif&q=10/',
  productFabricPreview: '?h=150&fm=avif&q=10/',
  fabrixCatalogThumb: '?fm=avif&q=10/',
  customizerCatalogThumbnail: '?h=512&fm=avif&q=10/',
  bannerImage: '?w=1920&h=1080&fm=avif&q=10',
  fabricConfigurator: '?h=512&fm=avif&q=10/',
  accessoriesPreview: '?h=100&fm=avif&q=10/',
};
